
import Swal from "sweetalert2";
export default {
    data() {
        return {
            deletar: false,
            responsive: false,
            notRead: true,
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50, 100],
                total: 0
            },
        }
    },

    computed: {
        queriedData() {
            let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            } else {
                if (this.search) {
                    result = []
                }
            }
            return result.slice(this.from, this.to);
        },

        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },

        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },

        total() {
            return this.searchedData.length > 0 ?
                this.searchedData.length : 0                
        }
    },

    methods: {
        searchOnTable() {
            this.searchedData = this.searchByName(this.tableData, this.search)            
        },
        
        toLower(text) {
            return text.toString().toLowerCase()
        },

        handleInactivate(id, name) {
            Swal.fire({
                title: this.titleInactivate,
                text: name.toUpperCase(),
                showCancelButton: true,
                customClass: {
                    confirmButton: "md-button md-success btn-fill",
                    cancelButton: "md-button md-danger btn-fill"
                },
                confirmButtonText: "SIM, " + this.titleInactivate,
                cancelButtonText: "CANCELAR",
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.inactivate(id)
                }
            });
        },

        inactivate(id) {
            let rota = this.titleInactivate == 'ATIVAR?' ? this.rotaActivate : this.rotaInactivate;
            this.$http.get(this.$urlAPI + rota + id)
                .then(response => {
                    if (response.data.status) {
                        this.activete = false
                        this.read();
                        this.success(response.data.message);
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        handleDelete(id, name, title = null) {
            let titleMessage = title ? title : 'EXCLUIR'
            Swal.fire({
                title: titleMessage + '?',
                text: name.toUpperCase(),
                showCancelButton: true,
                customClass: {
                    confirmButton: "md-button md-success btn-fill",
                    cancelButton: "md-button md-danger btn-fill"
                },
                confirmButtonText: "SIM, " + titleMessage,
                cancelButtonText: "CANCELAR",
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.delete(id)
                }
            });
        },

        delete(id) {
            let rota = this.deletar ? this.rotaDeletar : this.rotaExcluir;
            this.$http.delete(this.$urlAPI + rota + id)
                .then(response => {
                    if (response.data.status) {
                        this.deletar = false;
                        this.read();
                        this.success(response.data.message);
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },


        onResponsiveInverted() {
            if (window.innerWidth < 768) {
                this.responsive = true;
            } else {
                this.responsive = false;
            }
        }
    },

    mounted() {
        if (this.notRead) {            
            this.read()
        }
        this.onResponsiveInverted();
        window.addEventListener("resize", this.onResponsiveInverted);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResponsiveInverted);
    }

}